/*
 * @Author: Json Chen
 * @Date: 2021-06-24 09:38:57
 * @LastEditTime: 2021-06-24 09:39:23
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Product/config.ts
 */
export const breadcrumbData = ({ getI18n }) => [
  {
    url: '/',
    name: getI18n('general.sider.home'),
  },
  {
    url: '/settings',
    name: getI18n('general.sider.settings'),
  },
  {
    url: '/settings/product',
    name: getI18n('general.storeCommunicationSetting.product'),
  },
];
